<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('header.course') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            {{ $t('header.tagline') }}
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12">
              <h2 class="text-md-h4 font-weight-bold sub-title-page">
                {{ $t('header.education') }}
              </h2>
            </v-col>
            <v-col cols="12" md="12" class="text-justify">
              <p v-if="$i18n.locale === 'en'">
                PNB is academically driven but we also emphasize research implementations and social services. As a vocational institution, PNB focuses on developing knowledge and skills in applied sciences and technology. The ultimate educational goal is to develop well-rounded and highly-intelligent professionals with knowledge and skills sets demanded in the job markets and industries.
              </p>
              <p v-if="$i18n.locale === 'id'">
                Politeknik Negeri Bali tidak hanya mengemban misi pendidikan, tetapi juga melaksanakan tugas penelitian dan pengabdian masyarakat (pengabdian masyarakat), dengan memanfaatkan sumber daya manusia yang ada. Secara khusus, PNB merupakan penyelenggara pendidikan tinggi vokasi yang berfokus pada pengembangan pengetahuan dan keterampilan di bidang ilmu dan teknologi terapan. Sasaran pendidikan diarahkan pada pengembangan insan cerdas yang komprehensif dengan mengutamakan pengembangan sumber daya manusia yang profesional, dengan menyelenggarakan pendidikan berdasarkan kebutuhan pasar dan industri.
              </p>
            </v-col>
            <v-col cols="12" md="12" class="text-justify">
              <h2 class="text-md-h5 font-weight-bold mb-5 text-bg-black text-left" v-if="$i18n.locale === 'en'">
                <span>Explore Programs Available at PNB</span>
              </h2>
              <p v-if="$i18n.locale === 'en'">
                Follow your passion, or discover new ones. Politeknik Negeri Bali offers unparalleled student experiences across a broad spectrum of academic environments. Browse or search a specific program to learn more about admissions requirements, scholarships, and financial aid opportunities.
              </p>
              <h2 class="text-md-h5 font-weight-bold mb-5 text-bg-black text-left" v-if="$i18n.locale === 'id'">
                <span>Jelajahi Program yang Tersedia di PNB</span>
              </h2>
              <p v-if="$i18n.locale === 'id'">
                Ikuti hasrat Anda, atau temukan yang baru. Politeknik Negeri Bali menawarkan pengalaman mahasiswa yang tak tertandingi di spektrum yang luas dari lingkungan akademik. Jelajahi atau cari program tertentu untuk mempelajari lebih lanjut tentang persyaratan penerimaan, beasiswa, dan peluang bantuan keuangan.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages bacground-gray">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('./../assets/reg-class.jpeg')"
                position="center">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.regcourse') }}
                </v-card-title>
              </v-img>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-if="$i18n.locale === 'en'">
                  We offer several degree programs: D3, D4, masters, and doctoral programs in engineering and commerce.
                </div>
                <div v-if="$i18n.locale === 'id'">
                  Kami menawarkan beberapa program gelar: D3, D4, program magister, dan doktoral di bidang teknik dan perdagangan.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Coursereg' }">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('./../assets/int-class.jpeg')"
                position="center">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.intcourse') }}
                </v-card-title>
              </v-img>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-if="$i18n.locale === 'en'">
                  PNB partners with universities overseas to allow foreign students to study and experience not only our modern academic culture but also the Balinese traditional values. We offer the following programs for our inbound mobility.
                </div>
                <div v-if="$i18n.locale === 'id'">
                  PNB bermitra dengan universitas di luar negeri untuk memungkinkan mahasiswa asing belajar dan mengalami tidak hanya budaya akademik modern kita tetapi juga nilai-nilai tradisional Bali. Kami menawarkan program berikut untuk mobilitas masuk kami.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Courseint' }">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('./../assets/coop-class.jpeg')"
                position="center">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.coopcourse') }}
                </v-card-title>
              </v-img>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-if="$i18n.locale === 'en'">
                  PNB has strong cooperation and partnership programs with educational institutions across the globe. Below are some of our international partners.
                </div>
                <div v-if="$i18n.locale === 'id'">
                  PNB memiliki kerjasama yang kuat dan program kemitraan dengan lembaga pendidikan di seluruh dunia. Di bawah ini adalah beberapa mitra internasional kami.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Coursecoop' }">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('./../assets/rpl-class.jpeg')"
                position="center">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.rplcourse') }}
                </v-card-title>
              </v-img>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-if="$i18n.locale === 'en'">
                  PNB has cooperation and partnership with educational institutions all over the globe. Below are several of our international partners.
                </div>
                <div v-if="$i18n.locale === 'id'">
                  PNB memiliki kerjasama dan kemitraan dengan institusi pendidikan di seluruh dunia. Di bawah ini adalah beberapa mitra internasional kami.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Courserpl' }">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('./../assets/special-class.jpeg')"
                position="center">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.specialcourse') }}
                </v-card-title>
              </v-img>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-if="$i18n.locale === 'en'">
                  Politeknik Negeri Bali has developed cooperation and partnership with educational institutions all over the globe. Below are several of our international partners.
                </div>
                <div v-if="$i18n.locale === 'id'">
                  Politeknik Negeri Bali telah mengembangkan kerjasama dan kemitraan dengan institusi pendidikan di seluruh dunia. Di bawah ini adalah beberapa mitra internasional kami.
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  large
                  text
                  :to="{ name: 'Coursespe' }">
                  <v-icon :color="maincolor" large>
                    mdi-arrow-right-circle
                  </v-icon>
                  <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.newsedu') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="newslist.length">
        <v-col
          class="d-flex"
          cols="12"
          md="4"
          v-for="(news, i) in newslist"
          :key="i">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="news.urlpic">
            </v-img>
            <v-card-subtitle>
              <h1 class="title font-weight-bold mb-3">
                <router-link class="text-decoration-none text-ellipsis--2"
                  :title="news.judul_berita"
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  {{ news.judul_berita }}
                </router-link>
              </h1>
              <div class="d-flex">
                <v-chip
                  class="mr-1"
                  color="deep-orange"
                  small
                  dark
                  :title="news.tgl_berita">
                  <v-icon left small>
                    mdi-update
                  </v-icon>
                  <timeago :datetime="news.tgl_berita"></timeago>
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="primary"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-c-circle
                  </v-icon>
                  {{ news.cat_berita }}
                </v-chip>
                <v-spacer></v-spacer>
                <ShareNetwork
                  network="facebook"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="indigo">
                    mdi-facebook
                  </v-icon>
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                </ShareNetwork>
              </div>
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div v-html="news.prev_berita"></div>
            </v-card-text>
            <v-card-actions v-if="false">
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!newslist.length">
        <v-col cols="12" md="12">
          <div class="grey--text my-2">
            Berita pada kategori ini tidak ditemukan.
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Course',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/cov-course.jpg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    updateLanguage() {
      this.getBerita();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pendidikan';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
